import React, { FC } from 'react';
import { useSettings } from '@wix/yoshi-flow-editor/tpa-settings/react';

import { classes } from './Header.st.css';
import { SectionHeader } from '../common/SectionHeader';
import { CTAGroup } from '../common/CTAGroup';
import settingsParams from '../../settingsParams';

export const Header: FC = () => {
  const settings = useSettings();

  return (
    <div className={classes.root}>
      <div>
        <SectionHeader
          title={settings.get(settingsParams.pageSectionTitle)}
          subtitle={settings.get(settingsParams.pageSectionSubtitle)}
        />
      </div>
      <div>
        <CTAGroup />
      </div>
    </div>
  );
};
